// ============================================================
// Datei: src/pages/ressorts/food/FoodMobile.jsx
//
// ÄNDERUNGEN:
// - ShiftTable jetzt mit departmentName + filterFn
// - Aufbau / Festival / Abbau bleiben sauber getrennt
// - automatische Aktualisierung bleibt erhalten
// ============================================================

import React, { useState } from "react";

import VolunteerList from "../../../components/VolunteerList";
import VolunteerPool from "../../../components/VolunteerPool";
import ShiftTable from "../../../components/shiftTable/ShiftTable";

// Guests
import GuestRegistration from "../../../components/GuestRegistration";
import GuestList from "../../../components/guestList/GuestList";
import EditGuestModal from "../../../components/guestList/EditGuestModal";
import DeleteGuestModal from "../../../components/guestList/DeleteGuestModal";

import "./foodMobile.css";

const FoodMobile = ({
	volunteers,
	setVolunteers,
	shifts,
	guests,
	activeTab,
	setActiveTab,
	reloadGuests,
	reloadVolunteers,
	setSelectedVolunteer,
	downloadCcEmails
}) => {
	// ============================================================
	// STATE
	// ============================================================
	const [guestToEdit, setGuestToEdit] = useState(null);
	const [guestToDelete, setGuestToDelete] = useState(null);
	const [helpersSubTab, setHelpersSubTab] = useState("ressort");

	// ============================================================
	// SHIFTS
	// ============================================================
	const foodFestival = shifts.filter((s) => s.shiftId >= 401 && s.shiftId <= 410);
	const foodZmorge = shifts.filter((s) => s.shiftId >= 420 && s.shiftId <= 429);
	const foodAufbau = shifts.filter((s) => s.shiftId >= 430 && s.shiftId <= 459);
	const foodAbbau = shifts.filter((s) => s.shiftId >= 460 && s.shiftId <= 479);

	// ============================================================
	// TABS
	// ============================================================
	const tabs = [
		{ id: "overview", label: "Übersicht" },
		{ id: "helpers", label: "Libellen" },
		{ id: "shifts", label: "Schichtplan" },
		{ id: "guests", label: "Gästeliste" },
		{ id: "extras", label: "Extrawürscht" }
	];

	return (
		<>
			<div className="tabs-container">
				<div className="tab-bar">
					{tabs.map((t) => (
						<button
							key={t.id}
							type="button"
							className={
								"tab-button" +
								(activeTab === t.id ? " tab-button-active" : "")
							}
							onClick={() => setActiveTab(t.id)}
						>
							{t.label}
						</button>
					))}
				</div>

				<div className="tab-panels">
					{/* ================= HELPERS ================= */}
					{activeTab === "helpers" && (
						<div className="food-mobile-helpers-panel">
							<div className="helpers-subtab-bar">
								<button
									type="button"
									className={
										"helpers-subtab-button" +
										(helpersSubTab === "ressort"
											? " helpers-subtab-button-active"
											: "")
									}
									onClick={() => setHelpersSubTab("ressort")}
								>
									Ressort
								</button>

								<button
									type="button"
									className={
										"helpers-subtab-button" +
										(helpersSubTab === "pool"
											? " helpers-subtab-button-active"
											: "")
									}
									onClick={() => setHelpersSubTab("pool")}
								>
									Helferpool
								</button>
							</div>

							{helpersSubTab === "ressort" && (
								<VolunteerList
									volunteers={volunteers}
									setVolunteers={setVolunteers}
									onEdit={setSelectedVolunteer}
									reloadVolunteers={reloadVolunteers}
								/>
							)}

							{helpersSubTab === "pool" && (
								<VolunteerPool
									departmentName="Food"
									onAssigned={() => {
										if (reloadVolunteers) {
											reloadVolunteers();
										}
									}}
								/>
							)}
						</div>
					)}

					{/* ================= SHIFTS ================= */}
					{activeTab === "shifts" && (
						<>
						{/*	<h3 className="food-subheading">Aufbau</h3>
							<ShiftTable
								shifts={foodAufbau}
								departmentName="Food"
								autoRefresh={true}
								filterFn={(shift) => shift.shiftId >= 430 && shift.shiftId <= 459}
							/>
						*/}

							<h3 className="food-subheading">Festival</h3>
							<ShiftTable
								shifts={foodFestival}
								departmentName="Food"
								autoRefresh={false}
								filterFn={(shift) => shift.shiftId >= 401 && shift.shiftId <= 410}
							/>

							<h3 className="food-subheading">Zmorge</h3>
							<ShiftTable
								shifts={foodZmorge}
								departmentName="Food"
								autoRefresh={false}
								filterFn={(shift) => shift.shiftId >= 420 && shift.shiftId <= 429}
							/>

						{/*	<h3 className="food-subheading">Abbau</h3>
							<ShiftTable
								shifts={foodAbbau}
								departmentName="Food"
								autoRefresh={true}
								filterFn={(shift) => shift.shiftId >= 460 && shift.shiftId <= 479}
							/>
						*/}
						</>
					)}
					{/* ================= GUESTS ================= */}
					{activeTab === "guests" && (
						<>
							<GuestRegistration refreshGuestList={reloadGuests} />

							<GuestList
								guests={guests}
								refreshGuestList={reloadGuests}
								onEdit={(g) => setGuestToEdit(g)}
								onDelete={(g) => setGuestToDelete(g)}
							/>
						</>
					)}

					{/* ================= EXTRAS ================= */}
					{activeTab === "extras" && <div></div>}
				</div>
			</div>

			{guestToEdit && (
				<EditGuestModal
					guest={guestToEdit}
					onClose={() => setGuestToEdit(null)}
					onSaved={() => {
						setGuestToEdit(null);
						reloadGuests();
					}}
				/>
			)}

			{guestToDelete && (
				<DeleteGuestModal
					guest={guestToDelete}
					onClose={() => setGuestToDelete(null)}
					onDeleted={() => {
						setGuestToDelete(null);
						reloadGuests();
					}}
				/>
			)}
		</>
	);
};

export default FoodMobile;